/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type ItemEventsShownInput = {
    readonly userId: string;
    readonly clientMutationId?: string | null;
};
export type itemEventsShownMutationVariables = {
    readonly input: ItemEventsShownInput;
};
export type itemEventsShownMutationResponse = {
    readonly itemEventsShown: {
        readonly favoriteNotifications: {
            readonly hasNewEvents: boolean | null;
        } | null;
    } | null;
};
export type itemEventsShownMutation = {
    readonly response: itemEventsShownMutationResponse;
    readonly variables: itemEventsShownMutationVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "ItemEventsShownInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "hasNewEvents",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "itemEventsShownMutation",
            "type": "Mutations",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "itemEventsShown",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "ItemEventsShownPayload",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "favoriteNotifications",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "FavoriteNotifications",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "itemEventsShownMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "itemEventsShown",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "ItemEventsShownPayload",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "favoriteNotifications",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "FavoriteNotifications",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "id",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "mutation",
            "name": "itemEventsShownMutation",
            "id": "ferrum/233.0.0-2019-09-16T15:36:24.766Z/itemEventsShownMutation",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '1282ef6d92da32b74264cdd1393e3f71';
export default node;
